/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["label[_ngcontent-%COMP%]{width:100%}input[_ngcontent-%COMP%]{width:100%;height:100%}[_nghost-%COMP%]{width:9em!important}.fa-calendar-day[_ngcontent-%COMP%]{color:#cfcfcf;font-size:12px}"];
export { styles as styles };
